<template>
 <section class="newTable" >
  <table class="table datatable table-striped area-list-datatable" id="PrecisionMarketingDataTable" >
    <thead>
      <tr>
        <th width="120">
          <div class="checkbox checkbox-inline mr-0">
            <input 
            @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
            type="checkbox" 
            name="check-all" 
            id="check-all" 
            value="1" 
            v-model="checkAll">
            <label for="check-all"></label>
          </div>
          <span>#</span>
        </th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('name')"
        >姓名</th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'birthday' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('birthday')"
        >生日</th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'record' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('record')"
        >上次紀錄</th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'event_name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('event_name')"
        >重要事件</th>
        <th
        width="*"
        :class="'sorting ' + (order.fieldName == 'relationship' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('relationship')"
        >關係階段</th>
        <th
        width="250"
        class="text-center"
        :class="'sorting ' + (order.fieldName == 'address' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('address')"
        >地址</th>
        <th
        width="150"
        :class="'sorting ' + (order.fieldName == 'mkt_score' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting('mkt_score')"
        >泰好客<span class="questionmark-icon" @click="$emit('openInfoModal')">?</span></th>
        <th
        width="148">排訪</th>
      </tr>
    </thead>
    <tbody class="block-height" :style="{height: height + 'px'}">
        <tr v-for="(d, did) in tableDataBackup" :key="`PrecisionMarketingDataTable-table-td-${did}`">
          <td width="120">
            <div style="min-height: 30px;">
              <div class="mr-0 checkbox checkbox-inline">
                <input
                @click="clickTarget = clickTarget == `td-${did}`? `td-${did}-again`: `td-${did}`"
                type="checkbox"
                name="`td-item[]`"
                :id="`PrecisionMarketingDataTable-check-${did}`"
                :value="d.id"
                v-model="selection"
                :disabled="d.id === ''"
                @change="$emit('update', selection)">
                <label :for="`PrecisionMarketingDataTable-check-${did}`"></label>
              </div>
              
              <span>
              <span class="no">{{did + 1}}</span>
              <span class="info text-center">
                <level :lv="Number(d.vip_level)" />
                <avatar :gender="Number(d.sex)" :size="20" />
              </span>
              </span>
            </div>
          </td>
          <td width="*">
            <Tooltip  :position="did < 3 ?'bottom':'top'" :name="d.name" :id="d.id" :mobile="d.mobile" :birthday="d.birthday">
              <a v-if="d.is_exist" @click.prevent="routerToCust(d.id, d.name)" class="link text-underline">{{d.name | getMaskName}}</a>
              <a v-else>{{d.name | getMaskName}}</a>
            </Tooltip>
          </td>
          <td width="*">
            <span>
                <div class="date">
                  <span v-if="isROCFormat">{{d.birthday | getMaskBirthday}}</span>
                  <span v-else>{{d.birthday | dateFormat | getMaskBirthday}}</span>
                </div>
                <div class="age">
                  <b>{{ d.age? d.age : '— —' }}</b>歲
                </div>
              </span>
          </td>
          <td width="*">{{d.record | emptyField}}</td>
          <td width="*">{{d.event_name | emptyField}}</td>
          <td width="*">{{d.relationship | emptyField}}</td>
          <td width="250">{{d.address | getMaskAddress}}</td>
          <td width="150">
            <span class="mkt-type-use"
            :class="d.hos_mkt_level ? d.hos_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
            >住</span>
            <span class="mkt-type-use"
            :class="d.sur_mkt_level ? d.sur_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
            >手</span>
            <span class="mkt-type-use"
            :class="d.rei_mkt_level ? d.rei_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
            >實</span>
            <span class="mkt-type-use"
            :class="d.acc_mkt_level ? d.acc_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
            >意</span>
            <span class="mkt-type-use"
            :class="d.dd_mkt_level ? d.dd_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
            >重</span><br>
            <span class="mkt-type-use"
            :class="d.ltc_mkt_level ? d.ltc_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
            >長</span>
            <span class="mkt-type-use"
            :class="d.life_mkt_level ? d.life_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
            >壽</span>
            <span class="mkt-type-use"
            :class="d.sav_mkt_level ? d.sav_mkt_level == '1' ? 'bg-orange1' : 'bg-orange2' : 'bg-gray'"
            >儲</span>
            <span class="mkt-type-use"
            :class="d.inv_mkt_level ? d.inv_mkt_level == '1' ? 'bg-orange1' : 'bg-orange2' : 'bg-gray'"
            >投</span>
          </td>
          <td v-if="isBox" :width="iPadWidth">
            <button 
            v-if="!d.visit.csidno"
            class="btn btn-primary" 
            @click="callBoxVisit(d)"
            v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"></button>
            <button 
            v-else
            class="btn btn-primary" style="font-size:0.8rem;" 
            @click="callBoxVisit(d)">{{ d.visit.str_date | dateFormat }}<br>{{ d.visit.str_time }}</button>
          </td>
          <td v-else :width="iPadWidth">
            <button 
            v-if="!d.visit.csidno"
            class="btn btn-primary" 
            @click="$emit('scheduled-access', d)"
            v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"></button>
            <button 
            v-else
            class="btn btn-primary" style="font-size:0.8rem;" 
            @click="$emit('scheduled-access', d)">{{ d.visit.str_date | dateFormat }}<br>{{ d.visit.str_time }}</button>
          </td>
        </tr>
        <tr v-if="tableDataBackup.length == 0">
          <td colspan="8" class="text-center pt-3 pb-5">
            <h3>
              無客戶名單資料
            </h3>
          </td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
        </tr>
    </tbody>
  </table>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Level from "@/components/Level";
import Avatar from "@/components/Avatar";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
import Tooltip from "@/desktop/components/ToolTip";

const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad
let idmarkWidth = 148;
if (is_iPad) {
  idmarkWidth = 131;
}

export default {
  name: "EventDetectionDataTable",
  mixins: [commonMixin],
  components: { Level, Avatar, Tooltip },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    height: {
      type: Number,
      default: () => {
        return 350;
      }
    },
    //傳入日期已是民國格式
    isROCFormat:{
      type: Boolean,
      default: true
    },
    //名單專區資訊
    categoryInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      order: {
        fieldName: "name",
        asc: true
      },
      checkAll: false,
      clickTarget: "",
      tableDataBackup: [],
      allIdData: [],
      selection: [],
      currentWidth: 0,
      is_iPad: is_iPad,
      iPadWidth: idmarkWidth
    };
  },
  computed : {
    ...mapGetters([ 'UserInfo' ]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === 'box';
    }
  },
  watch: {
    tableData: function() {
      this.init();
    },
    clickTarget: function(target) {
      if (target == "clickAll" || target == "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.allIdData.forEach((data) => {
            this.selection.push(data);
          });
        } else {
          //取消全選
          this.selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.allIdData.length;
      }
      this.$emit("update", this.selection);
    }
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    columnSorting(fieldName) {
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.fieldName = fieldName;
        this.order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "birthday":
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.sortCompareFun(sortOrder, "birthdaySort")
            );
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        case "record":
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.dateCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.sortCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    dateCompareFun(sortOrder, property) {
      let vm = this;
      return function(a, b) {
        let aBir =
          a[property].replace(/\/.*/g, "") * 1 +
          1911 +
          a[property].replace(/^.*(?=\/\d{2}\/)/, "");
        let bBir =
          b[property].replace(/\/.*/g, "") * 1 +
          1911 +
          b[property].replace(/^.*(?=\/\d{2}\/)/, "");
        let date_a = new Date(a[property] ? aBir : "1880-01-01").getTime();
        let date_b = new Date(b[property] ? bBir : "1880-01-01").getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    routerToCust(custID, custName) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(custID, custName);
      } else {
        this.updateCustID(custID);
        localStorage.CustID = custID;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    init() {
      this.checkAll = false;
      this.selection = [];
      this.tableDataBackup = this.tableData.map((ele) => {
        return ele;
      });
      this.allIdData = this.tableData.map((ele) => {
        return ele.id;
      });
      this.order.fieldName = "name";
      this.order.asc = true;
      this.registerHanlink(); // for hard word
    },
    callBoxVisit(data) {
      //連至Box排訪
      this.boxVisit(data, this.categoryInfo);
    },
    //回傳當前排序資料集
    getSortedList() {
      return this.tableDataBackup;
    },
  },
  mounted() {
    this.currentWidth =
      this.$el.clientWidth * (this.$el.clientWidth < 1250 ? 0.95 : 1);
    if (!is_iPad) {
      this.iPadWidth = "131";
    } else {
      this.iPadWidth = "148";
    }
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

.bg-green1 {
  background-color: rgb(0,128,0);
}

.bg-green2 {
  background-color: rgb(146,208,80);
}

.bg-gray {
  background-color: rgb(230,230,230);
}

.bg-orange1 {
  background-color: rgb(245, 136, 26);
}

.bg-orange2 {
  background-color: rgb(244, 177, 131);
}

.mkt-type-use {
  padding: 1px 4px;
  display: inline-block;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  color: #fff;
  font: 14px Arial, sans-serif;
  font-weight: 600;
  margin-bottom: 2px;
  margin-right: 3px;
}

.questionmark-icon {
  border-radius: 50%;
  border:2px solid #fff;
  width: 36px;
  height: 36px;
  padding: 1px 4px 1px 4px;
  color: #fff;
  text-align: center;
  font: 12px Arial, sans-serif;
  font-weight: 600;
  cursor: pointer;
}
</style>